import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BRAND_LOGO_ICON_192_URL } from "./utils/runtimeConfig";

const setLinkHref = (rel, href) => {
  if (!href) return;
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement("link");
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.href = href;
};

setLinkHref("icon", BRAND_LOGO_ICON_192_URL);
setLinkHref("apple-touch-icon", BRAND_LOGO_ICON_192_URL);

try {
  const savedTheme = localStorage.getItem("theme");
  if (savedTheme === "dark") {
    document.body.classList.add("dark");
  } else {
    document.body.classList.remove("dark");
  }
} catch (e) {
  // noop
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);
